// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React, { Component } from 'react';
import Loading from 'react-loading';
import downloadable from '../utilities/downloadable';
import api from '../api';

export default class FileUpload extends Component {

    state = {
        downloading: false,
        file: ""
    }

    componentDidMount = () => {
        this.dialog = document.createElement("input");
        this.dialog.setAttribute("type", "file");
        this.setFilename(this.props.value);
    }

    componentWillReceiveProps = (next) => {
        if (this.props.value !== next.value)
            this.setFilename(next.value);
    }

    setFilename = (file) => {
        this.setState({ file });
    }

    uploadFileDialog = () => {
        this.dialog.click();
        this.dialog.onchange = (e) => {
            var path;
            if (e.path)
                path = e.path;
            else if (e.composedPath && e.composedPath())
                path = e.composedPath();
            else return;

            this.props.uploadFile(path[0].files);
        }
    }

    downloadFile = async (file) => {
        this.setState({ downloading: true });
        const res = await api.download('/module/downloadConfigFile?stackId=' + this.props.stackId + '&file=' + file);
        downloadable(res, file.split("/").pop());
        this.setState({ downloading: false });
    }

    render = () => {
        let filename;
        if (this.props.value) {
            const pathCmp = this.props.value.split("/");
            filename = pathCmp[pathCmp.length-1];
        }

        return (this.props.uploading ? <div className="config-file-uploading">
            <Loading
                type="bubbles"
                color="var(--color-primary-dark)"
                height={80}
                width={80}
            />
            <h3 style={{
                marginLeft: -290
            }}>Uploading file...</h3>
        </div> : <>
            <div
                className={"config-file" + (this.state.dragOver ? " config-file-drag" : "")}
                onDrop={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.setState({ dragOver: false });
                    let files = [];
                    if (e.dataTransfer.items)
                        for (let item of e.dataTransfer.items)
                            files.push(item.getAsFile());
                    if (files.length <= 0) return;
                    this.props.uploadFile(files);
                }}
                onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
                onDragEnter={() => this.setState({ dragOver: true })}
                onDragLeave={() => this.setState({ dragOver: false })}
                onClick={this.uploadFileDialog}
            >
                <h3>{filename ? "File: " + filename : "Click or Drop a file here"}</h3>
                <p>{filename ? "Click to upload another file..." : "Upload a file to use within the module."}</p>
            </div>
            {this.state.downloading ? <div className="config-file-downloading">Preparing download...</div> : filename ? <div className="config-file-download" onClick={() => this.downloadFile(this.props.value)}>Download file: {filename}</div> : ""}
        </>);
    }

}